import React from 'react'
import PrimaryTitle from '../components/PrimaryTitle'
import { Link } from 'react-router-dom'
import t from '../service/translate.service'
import historyService from '../service/history.service'

const HomepageOverlay = () => {
  return (
    <div className="homepage-overlay" role="region" aria-labelledby="overlay-title">
      <PrimaryTitle id="overlay-title" title={t.OVERLAY_TITLE} />
  
      <div className="text-center">
        <Link 
          to="/contracts/add-contract" 
          className="button primary" 
          aria-label={t.ADD_A_CONTRACT_BUTTON}
        >
          {t.ADD_A_CONTRACT_BUTTON}
        </Link>
      </div>
    </div>
  );
}

export default HomepageOverlay
